import React, { useEffect, useRef, useState } from "react";
import { FaPencilAlt, FaStar } from "react-icons/fa";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CLIENT } from "../../Router/paths";
import User from "../../assets/images/james-img.png";
import { axiosInstance } from "../../config/https";
import { useLoader, useModal } from "../../context/LoaderContext";

export default function FreelancerProfileComp() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state, pathname } = useLocation();
  const { startLoader, stopLoader } = useLoader();
  const { openModal } = useModal();
  const isClient = pathname.includes("client");
  const [profile, setProfile] = useState(null);
  const [profilePic, setProfilePic] = useState(null);
  const ProfileInput = useRef();
  // const loginUser = JSON.parse(localStorage.getItem('user'))

  useEffect(() => {
    if (isClient) {
      const getFreelancers = () => {
        startLoader();
        axiosInstance
          .get(`/api/seller/sellersinfo/?user_id=${id}`)
          .then((resp) => {
            stopLoader();
            const Data = resp.data;
            if (resp.status === 200 || resp.status === 201) {
              setProfile(Data[0]);
            } else {
              toast.warning(Data.msg);
            }
          })
          .catch(() => {
            stopLoader();
          });
      };
      getFreelancers();
    } else {
      const getProfile = () => {
        startLoader();
        axiosInstance
          .get(`/api/seller/sellersinfo`)
          // /?user_id=${loginUser?.user?.id}
          .then((resp) => {
            stopLoader();
            const Data = resp.data;
            if (resp.status === 200 || resp.status === 201) {
              localStorage.setItem("user", JSON.stringify(Data[0]));
              setProfile(Data[0]);
            } else {
              toast.warning(Data.msg);
            }
          })
          .catch(() => {
            stopLoader();
          });
      };
      getProfile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getProfilePic = () => {
    startLoader();
    axiosInstance
      .get("/api/seller/profile-picture/")
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          // setProfile(Data[0]);
          setProfilePic(
            process.env.REACT_APP_API_URL + Data.data.profile_picture
          );
          localStorage.setItem("profile", Data[0]);
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  const handleProfilePic = (e) => {
    startLoader();
    const formData = new FormData();
    formData.append("profile_picture", e.target.files[0]);
    axiosInstance
      .post("/api/seller/profile-picture/", formData)
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          toast.success("Profile Update Successfully");
          getProfilePic();
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  const hire = () => {
    startLoader();
    axiosInstance
      .patch(`/api/jobposts/${state.jobId}/`, {
        freelancer: id,
      })
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          toast.success("Hire Succesfully");
          navigate(CLIENT.reviewProposals(state.jobId));
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  const handleStripe = () => {
    openModal(
      "card", //gif url
      "Card Credentials!", //title
      "Enter your card information below to proceed with the secure payment process." //subtitle
    );
    setTimeout(() => {
      startLoader();
      if (profile?.user?.stripe_account !== null) {
        LinkWithStripe();
      } else {
        axiosInstance
          .post("/api/create-stripe-account/")
          .then((resp) => {
            stopLoader();
            if (resp.status === 200 || resp.status === 201) {
              LinkWithStripe();
            }
          })
          .catch(() => {
            stopLoader();
          });
      }
    }, 2000);
  };

  const LinkWithStripe = () => {
    startLoader();
    axiosInstance
      .post("/api/create-stripe-account-link/")
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          window.open(Data.url, "_blank");
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  const handleDownload = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "image.png";
    link.click();
  };

  return (
    <section className="contractor-profile-sec pc-p-3">
      <div className="container align-items-center justify-content-center">
        <div className="row align-items-center">
          <div className="col-lg-12 col-12">
            <div className="profile-main-box">
              <div className="profile-sec-box">
                <div className="row align-items-center justify-content-center">
                  <div className="col-lg-3">
                    <div className="client-box">
                      <img
                        src={
                          profilePic
                            ? profilePic
                            : profile?.profile_picture?.profile_picture || User
                        }
                        alt="pro img"
                      />
                      <input
                        type="file"
                        ref={ProfileInput}
                        onChange={handleProfilePic}
                        hidden
                      />
                      <div className="edit-icon">
                        <Link
                          style={{ cursor: "pointer" }}
                          onClick={() => ProfileInput.current.click()}
                        >
                          <i>
                            <FaPencilAlt />
                          </i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="primary-heading color-dark client-profile-content">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="client-profile">
                      <div className="mt-3">
                        <h5 htmlFor="">Name:-</h5>
                        <p>{profile?.user?.name}</p>
                      </div>
                      <hr />
                      <div className="mt-3">
                        <h5 htmlFor="">Email Address:-</h5>
                        <p>{profile?.user?.email}</p>
                      </div>
                      <hr />
                      <div className="mt-3">
                        <h5 htmlFor="">Skills:-</h5>
                        <ul>
                          {profile?.skills?.map((e, i) => (
                            <li key={i}>{e?.name}</li>
                          ))}
                        </ul>
                      </div>
                      <hr />
                      {/* <div className="mt-3">
                        <h5 htmlFor="">Social:-</h5>
                        <ul>
                          <li>Linkedin</li>
                        </ul>
                      </div> */}
                      {profile?.resume && (
                        <>
                          <div className="mt-3">
                            <h5 htmlFor="">Resume:-</h5>
                            <span
                              onClick={() => handleDownload(profile?.resume)}
                              style={{ cursor: "pointer" }}
                              className="p-link mt-2"
                            >
                              Download Resume
                            </span>
                          </div>
                          <hr />
                        </>
                      )}
                      {!isClient && (
                        <div className="mt-3">
                          <h5 htmlFor="">Stripe:-</h5>
                          {/* {profile.?resume} */}
                          <button
                            className="primary-btn primary-bg mt-2"
                            style={{ padding: "0.8rem" }}
                            type="button"
                            onClick={handleStripe}
                          >
                            Attach Stripe Account
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-9">
                    <div className="client-profile bd-left">
                      {/* <div className="mt-3">
                        <h5 htmlFor="">Title:-</h5>
                        <p>Frontend Developer</p>
                      </div> */}
                      <div className="mt-3">
                        <h5 htmlFor="">Description:-</h5>
                        <p style={{ textAlign: "justify" }}>
                          {profile?.description}
                        </p>
                      </div>
                      {profile?.calculate_overall_rating !== 0 && (
                        <div className="mt-3">
                          <h5 htmlFor="">Rating:-</h5>
                          <div className="rating-p mt-3">
                            {/* <p>Lorem Ipsum Dollar</p> */}
                            <ul className="list-inline">
                              {Array(
                                Math.round(
                                  profile?.calculate_overall_rating || 0
                                )
                              )
                                .fill()
                                .map((_, i) => (
                                  <li key={i} className="list-inline-item">
                                    <FaStar />
                                  </li>
                                ))}
                              {/* <FaRegStar /> */}
                            </ul>
                          </div>
                        </div>
                      )}
                      <div className="mt-3">
                        <h5 htmlFor="">Portfolio:-</h5>
                        <a
                          href={profile?.personal_website}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {profile?.personal_website}
                        </a>
                      </div>
                      {profile?.images.length > 0 && (
                        <div className="mt-3">
                          <h5 htmlFor="">Projects Gallery:-</h5>
                          <div className="gallery">
                            <div className="row">
                              {profile?.images?.map((e, i) => (
                                <div className="col-lg-4 col-md-6 col-12">
                                  <div className="gallery-box" key={i}>
                                    <a
                                      href={e?.image}
                                      data-fancybox="gallery"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <div className="gallery-img">
                                        <img src={e?.image} alt="Portfolio" />
                                      </div>
                                    </a>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  {isClient && (
                    <Link
                      // to={FREELANCER.hire}
                      onClick={hire}
                      className="primary-btn primary-bg mt-4"
                    >
                      Confirm Hire
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
